import moment from "moment";

export function groupFuelDataByGroupingName(data, interval) {
    // console.log(data, interval);
    return new Promise((done, _) => {
        const groupedData = [];
        let currentGroup = {
            startDate: null,
            endDate: null,
            count: 0,
            fuel_consumed: 0,

            manual_refuel_quantity: 0,
            manual_based_fuel_consumed: 0,

            idle_time_min: 0,

            total_refuel: 0,
            total_theft: 0,

            start_meter: null,
            end_meter: null,

            // distance_travelled: 0,
            start_meter_effective: null,
            end_meter_effective: null,
            // distance_travelled_effective: 0,
            // consumption_rate: 0,
            total_consumption_rate: 0, // Accumulate consumption_rate here
            total_consumption_rate_ignition: 0, // Accumulate consumption_rate_ignition here

            total_consumption_rate_manual_refuel: 0,
            total_consumption_rate_manual_refuel_hours: 0,
            moving_time_min: 0,

            idle_time_ms: 0,
            ignition_time_ms: 0,
            moving_time_ms: 0,
            ignition_time_min: 0,
        };

        data.forEach((item, index) => {
            const itemDate = item.date_timestamp ? moment(item.date_timestamp) : moment(item.date);
            if (!currentGroup.startDate) {
                currentGroup.startDate = item.date_timestamp ? moment(item.date_timestamp).format('YYYY-MM-DD') : moment(item.date).format('YYYY-MM-DD');
                currentGroup.start_meter = Number(item.start_meter);
                // currentGroup.start_meter_effective = Number(item.start_meter_effective);
                currentGroup.start_meter_effective = Number(item.start_meter);
            }

            // if ((interval === 'w' && currentGroup.count === 7) || (interval === 'm' && index === data.length - 1)) {
            if (
                (interval === 'w' && itemDate.isoWeekday() === 7) || // End of the week (Sunday)
                (interval === 'm' && itemDate.date() === itemDate.daysInMonth()) || // End of the month
                (interval === 'y' && itemDate.month() === 11 && itemDate.date() === 31) // End of the year
            ) {

                currentGroup.endDate = item.date_timestamp ? moment(item.date_timestamp).format('YYYY-MM-DD') : moment(item.date).format('YYYY-MM-DD');
                currentGroup.end_meter = Number(item.end_meter);
                // currentGroup.end_meter_effective = Number(item.end_meter_effective);
                currentGroup.end_meter_effective = Number(item.end_meter);

                currentGroup.fuel_consumed += Number(item.fuel_consumed);
                currentGroup.idle_time_min += Number(item.idle_time_min);
                currentGroup.moving_time_min += Number(item.moving_time_min);

                currentGroup.manual_refuel_quantity += item.manualRefualQuantity ? Number(item.manualRefualQuantity) : 0;
                // Calculate manual based fuel consumed
                // console.log('item.manualRefualIsFullTank', item.manualRefualIsFullTank)               

                currentGroup.manual_based_fuel_consumed += item.manual_based_fuel_consumed
                // console.log('manual_based_fuel_consumed', (fuelConsumed - totalRefuel + manualRefuelQuantity))


                currentGroup.total_refuel += Number(item.total_refuel);
                currentGroup.total_theft += Number(item.total_theft);

                currentGroup.idle_time_ms += Number(item.idle_time_ms);
                currentGroup.ignition_time_ms += Number(item.ignition_time_ms);
                currentGroup.moving_time_ms += Number(item.moving_time_ms);

                currentGroup.ignition_time_min += Number(item.ignition_time_min);

                const distance_travelled = currentGroup.end_meter - currentGroup.start_meter;
                // ignore the effective meters
                // const distance_travelled_effective = currentGroup.end_meter_effective - currentGroup.start_meter_effective;
                const distance_travelled_effective = currentGroup.end_meter - currentGroup.start_meter;

                // Calculate the consumption rate (average of individual consumption_rate values)
                const consumption_rate = avg_consumption_rate;

                const ignitionTimeHours = currentGroup.ignition_time_ms > 0 ? currentGroup.ignition_time_ms / (60 * 60 * 1000) : 0;
                const consumption_rate_ignition = currentGroup.fuel_consumed ? ignitionTimeHours / currentGroup.fuel_consumed : 0;


                // currentGroup.distance_travelled += Number(item.end_meter) - Number(item.start_meter);
                // currentGroup.distance_travelled_effective += Number(item.distance_travelled_effective);
                // currentGroup.total_consumption_rate += Number(item.consumption_rate);


                // currentGroup.distance_travelled += Number(item.distance_travelled);
                // currentGroup.distance_travelled_effective += Number(item.distance_travelled_effective);
                currentGroup.total_consumption_rate += Number(item.consumption_rate || 0);
                // currentGroup.moving_time_min += Number(item.moving_time_min);

                const avg_consumption_rate = currentGroup.count > 0 ? currentGroup.total_consumption_rate / currentGroup.count : 0;


                currentGroup.total_consumption_rate_manual_refuel += Number(item.consumption_rate_manual_refuel || 0);
                currentGroup.total_consumption_rate_manual_refuel_hours += Number(item.consumption_rate_manual_refuel_hours || 0);

                // currentGroup.count += 1;
                groupedData.push({
                    date: moment(currentGroup.startDate).format('DD-MM') + ' to ' + moment(currentGroup.endDate).format('DD-MM'),
                    fuel_consumed: currentGroup.fuel_consumed,
                    start_meter: currentGroup.start_meter,
                    start_meter_effective: currentGroup.start_meter_effective,
                    end_meter: currentGroup.end_meter,
                    end_meter_effective: currentGroup.end_meter_effective,
                    idle_time_min: currentGroup.idle_time_min,
                    moving_time_min: currentGroup.moving_time_min,

                    total_refuel: currentGroup.total_refuel,
                    total_theft: currentGroup.total_theft,

                    idle_time_ms: currentGroup.idle_time_ms,
                    ignition_time_ms: currentGroup.ignition_time_ms,
                    moving_time_ms: currentGroup.moving_time_ms,
                    ignition_time_min: currentGroup.ignition_time_min,
                    distance_travelled: distance_travelled,
                    distance_travelled_effective: distance_travelled_effective,
                    consumption_rate: consumption_rate, //currentGroup.consumption_rate,
                    consumption_rate_ignition: consumption_rate_ignition,
                    consumption_rate_manual_refuel: currentGroup.count > 0 ? currentGroup.total_consumption_rate_manual_refuel / currentGroup.count : 0,
                    consumption_rate_manual_refuel_hours: currentGroup.count > 0 ? currentGroup.total_consumption_rate_manual_refuel_hours / currentGroup.count : 0,

                    manual_refuel_quantity: currentGroup.manual_refuel_quantity,
                    manual_based_fuel_consumed: currentGroup.manual_based_fuel_consumed,

                });
                currentGroup = {
                    startDate: null, endDate: null, count: 0, fuel_consumed: 0,
                    idle_time_min: 0,
                    start_meter: null,
                    end_meter: null,
                    // distance_travelled: 0,
                    start_meter_effective: null,
                    end_meter_effective: null,
                    // distance_travelled_effective: 0,
                    // consumption_rate: 0,
                    total_consumption_rate: 0, // Reset the total consumption rate
                    total_consumption_rate_manual_refuel: 0,
                    total_consumption_rate_manual_refuel_hours: 0,
                    moving_time_min: 0,
                    total_refuel: 0,
                    total_theft: 0,
                    idle_time_ms: 0,
                    ignition_time_ms: 0,
                    moving_time_ms: 0,
                    ignition_time_min: 0,

                    manual_refuel_quantity: 0,
                    manual_based_fuel_consumed: 0,
                };
            } else {
                currentGroup.endDate = item.date;
                currentGroup.end_meter = item.end_meter;
                currentGroup.end_meter_effective = item.end_meter_effective;

                currentGroup.fuel_consumed += Number(item.fuel_consumed);
                currentGroup.idle_time_min += Number(item.idle_time_min);
                currentGroup.moving_time_min += Number(item.moving_time_min);
                currentGroup.ignition_time_min += Number(item.ignition_time_min);

                currentGroup.total_refuel += Number(item.total_refuel);
                currentGroup.total_theft += Number(item.total_theft);

                // currentGroup.distance_travelled = currentGroup.end_meter - currentGroup.start_meter;
                // currentGroup.distance_travelled_effective = currentGroup.end_meter_effective - currentGroup.start_meter_effective;
                currentGroup.total_consumption_rate += Number(item.consumption_rate || 0);
                currentGroup.total_consumption_rate_manual_refuel += Number(item.consumption_rate_manual_refuel || 0);
                currentGroup.total_consumption_rate_manual_refuel_hours += Number(item.consumption_rate_manual_refuel_hours || 0);

                currentGroup.idle_time_ms += Number(item.idle_time_ms);
                currentGroup.ignition_time_ms += Number(item.ignition_time_ms);
                currentGroup.moving_time_ms += Number(item.moving_time_ms);

                currentGroup.manual_refuel_quantity += item.manualRefualQuantity ? Number(item.manualRefualQuantity) : 0;
                // Calculate manual based fuel consumed

                const fuelConsumed = Number(item.fuel_consumed)
                const totalRefuel = Number(item.total_refuel)
                const manualRefuelQuantity = item.manualRefualQuantity ? Number(item.manualRefualQuantity) : 0
                currentGroup.manual_based_fuel_consumed += fuelConsumed - totalRefuel + manualRefuelQuantity
                // console.log('manual_based_fuel_consumed*', (fuelConsumed - totalRefuel + manualRefuelQuantity))

                currentGroup.count += 1;
            }

        });

        // if anything remains
        if (currentGroup.count > 0) {
            const avg_consumption_rate = currentGroup.count > 0 ? currentGroup.total_consumption_rate / currentGroup.count : 0;
            const distance_travelled = currentGroup.end_meter - currentGroup.start_meter;
            // const distance_travelled_effective = currentGroup.end_meter_effective - currentGroup.start_meter_effective;
            const distance_travelled_effective = currentGroup.end_meter - currentGroup.start_meter;
            const consumption_rate = avg_consumption_rate;

            groupedData.push({
                // date: currentGroup.startDate + ' to ' + currentGroup.endDate,
                date: moment(currentGroup.startDate).format('DD-MM') + ' to ' + moment(currentGroup.endDate).format('DD-MM'),
                fuel_consumed: currentGroup.fuel_consumed,
                start_meter: currentGroup.start_meter,
                start_meter_effective: currentGroup.start_meter_effective,
                end_meter: currentGroup.end_meter,
                end_meter_effective: currentGroup.end_meter_effective,
                idle_time_min: currentGroup.idle_time_min,
                distance_travelled: distance_travelled, // Diff between start and end meters
                distance_travelled_effective: distance_travelled_effective, // Diff between start and end meters (effective)
                consumption_rate: consumption_rate, // Effective distance travelled / fuel consumed       
                moving_time_min: currentGroup.moving_time_min,
                total_refuel: currentGroup.total_refuel,
                total_theft: currentGroup.total_theft,
                idle_time_ms: currentGroup.idle_time_ms,
                ignition_time_ms: currentGroup.ignition_time_ms,
                moving_time_ms: currentGroup.moving_time_ms,
                consumption_rate_manual_refuel: currentGroup.count > 0 ? currentGroup.total_consumption_rate_manual_refuel / currentGroup.count : 0,
                consumption_rate_manual_refuel_hours: currentGroup.count > 0 ? currentGroup.total_consumption_rate_manual_refuel_hours / currentGroup.count : 0,
                consumption_rate_ignition: currentGroup.fuel_consumed > 0 ? (currentGroup.ignition_time_ms / (60 * 60 * 1000)) / currentGroup.fuel_consumed : 0,
                ignition_time_min: currentGroup.ignition_time_min,

                manual_refuel_quantity: currentGroup.manual_refuel_quantity,
                manual_based_fuel_consumed: currentGroup.manual_based_fuel_consumed,
            });
        }
        done(groupedData);
    })
};

// non iot data
export function groupManualDataByGroupingName(data, interval) {
    // console.log(data, interval);
    return new Promise((done, _) => {
        const groupedData = [];
        let currentGroup = {
            startDate: null,
            endDate: null,
            count: 0,

            quantity: 0,
            hours_reading: 0,
            kms_reading: 0,
            hours_consumed: 0,
            kms_consumed: 0,
            hours_qty: 0,
            qty_hours: 0,
            kms_qty: 0,
            qty_kms: 0,

        };

        data.forEach((item, index) => {
            const itemDate = moment(item.date, 'DD-MM-YYYY');
            if (!currentGroup.startDate) {
                currentGroup.startDate = moment(item.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
            }

            // if ((interval === 'w' && currentGroup.count === 7) || (interval === 'm' && index === data.length - 1)) {
            if (
                (interval === 'w' && itemDate.isoWeekday() === 7) || // End of the week (Sunday)
                (interval === 'm' && itemDate.date() === itemDate.daysInMonth()) || // End of the month
                (interval === 'y' && itemDate.month() === 11 && itemDate.date() === 31) // End of the year
            ) {

                currentGroup.endDate = item.date;

                currentGroup.quantity += Number(item.quantity);
                currentGroup.hours_reading += Number(item.hours_reading);
                currentGroup.kms_reading += Number(item.kms_reading);
                currentGroup.hours_consumed += Number(item.hours_consumed);
                currentGroup.kms_consumed += Number(item.kms_consumed);
                currentGroup.hours_qty += Number(item.hours_qty);
                currentGroup.qty_hours += Number(item.qty_hours);
                currentGroup.kms_qty += Number(item.kms_qty);
                currentGroup.qty_kms += Number(item.qty_kms);

                // currentGroup.count += 1;
                groupedData.push({
                    date: moment(currentGroup.startDate).format('DD-MM') + ' to ' + moment(currentGroup.endDate).format('DD-MM'),

                    quantity: currentGroup.quantity,
                    hours_reading: currentGroup.hours_reading,
                    kms_reading: currentGroup.kms_reading,
                    hours_consumed: currentGroup.hours_consumed,
                    kms_consumed: currentGroup.kms_consumed,
                    hours_qty: currentGroup.hours_qty,
                    qty_hours: currentGroup.qty_hours,
                    kms_qty: currentGroup.kms_qty,
                    qty_kms: currentGroup.qty_kms,

                });
                currentGroup = {
                    startDate: null, endDate: null, count: 0,
                    quantity: 0,
                    hours_reading: 0,
                    kms_reading: 0,
                    hours_consumed: 0,
                    kms_consumed: 0,
                    hours_qty: 0,
                    qty_hours: 0,
                    kms_qty: 0,
                    qty_kms: 0,
                };
            } else {
                currentGroup.endDate = moment(item.date, 'DD-MM-YYYY').format('YYYY-MM-DD');


                // currentGroup.quantity += Number(item.quantity);
                // currentGroup.hours_reading += Number(item.hours_reading);
                // currentGroup.kms_reading += Number(item.kms_reading);
                // currentGroup.hours_consumed += Number(item.hours_consumed);
                // currentGroup.kms_consumed += Number(item.kms_consumed);
                // currentGroup.hours_qty += Number(item.hours_qty);
                // currentGroup.qty_hours += Number(item.qty_hours);
                // currentGroup.kms_qty += Number(item.kms_qty);
                // currentGroup.qty_kms += Number(item.qty_kms);

                currentGroup.count += 1;
            }

        });

        // if anything remains
        if (currentGroup.count > 0) {
            groupedData.push({
                // date: currentGroup.startDate + ' to ' + currentGroup.endDate,
                date: moment(currentGroup.startDate).format('DD-MM') + ' to ' + moment(currentGroup.endDate).format('DD-MM'),
                quantity: currentGroup.quantity,
                hours_reading: currentGroup.hours_reading,
                kms_reading: currentGroup.kms_reading,
                hours_consumed: currentGroup.hours_consumed,
                kms_consumed: currentGroup.kms_consumed,
                hours_qty: currentGroup.hours_qty,
                qty_hours: currentGroup.qty_hours,
                kms_qty: currentGroup.kms_qty,
                qty_kms: currentGroup.qty_kms,
            });
        }
        done(groupedData);
    })
};

// Helper function to parse date strings
const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day)
};

// Helper function to get the start of the week (Monday)
const getStartOfWeek = (date) => {
    const startOfWeek = new Date(date);
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    startOfWeek.setDate(diff);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    return moment(startOfWeek).format('DD-MM') + ' to ' + moment(endOfWeek).format('DD-MM');
};

// Helper function to get the start of the month
const getStartOfMonth = (date) => {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return moment(startOfMonth).format('DD-MM') + ' to ' + moment(endOfMonth).format('DD-MM');
    // return new Date(date.getFullYear(), date.getMonth(), 1);
};

// Helper function to get the start of the year
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const endOfYear = new Date(date.getFullYear(), 11, 31);
    return moment(startOfYear).format('MM-YYYY') + ' to ' + moment(endOfYear).format('MM-YYYY');
    // return { startOfYear, endOfYear };
    // return new Date(date.getFullYear(), 0, 1);
};

// Main function to group data
export function groupManualData(data, groupName) {
    let getStartFunction;

    // Determine which grouping function to use
    switch (groupName) {
        case 'd':
            getStartFunction = (date) => moment(date).format('DD-MM-YYYY');
            break;
        case 'w':
            getStartFunction = getStartOfWeek;
            break;
        case 'm':
            getStartFunction = getStartOfMonth;
            break;
        case 'y':
            getStartFunction = getStartOfYear;
            break;
        default:
            getStartFunction = (date) => moment(date).format('DD-MM-YYYY');
    }

    // Group the data
    return data.reduce((acc, item) => {
        const date = parseDate(item.date);
        const startOfPeriod = getStartFunction(date); // Get start of the period in YYYY-MM-DD format

        if (!acc[startOfPeriod]) {
            acc[startOfPeriod] = {
                date: startOfPeriod, // Use startOfPeriod as a key, customize the format as needed
                quantity: 0,
                hours_reading: 0,
                kms_reading: 0,
                hours_consumed: 0,
                kms_consumed: 0,
                hours_qty: 0,
                qty_hours: 0,
                kms_qty: 0,
                qty_kms: 0,
                moving_time: 0,
                idle_time: 0,
            };
        }

        // Sum up the fields
        acc[startOfPeriod].quantity += item.quantity;
        acc[startOfPeriod].hours_reading += item.hours_reading;
        acc[startOfPeriod].kms_reading += item.kms_reading;
        acc[startOfPeriod].hours_consumed += item.hours_consumed;
        acc[startOfPeriod].kms_consumed += item.kms_consumed;

        // acc[startOfPeriod].hours_qty += item.hours_qty;
        // acc[startOfPeriod].qty_hours += item.qty_hours;
        // acc[startOfPeriod].kms_qty += item.kms_qty;
        // acc[startOfPeriod].qty_kms += item.qty_kms;

        acc[startOfPeriod].hours_qty = acc[startOfPeriod].quantity ? Number(acc[startOfPeriod].hours_consumed) / Number(acc[startOfPeriod].quantity).toFixed(2) : 0;
        acc[startOfPeriod].qty_hours = acc[startOfPeriod].hours_consumed ? Number(acc[startOfPeriod].quantity) / Number(acc[startOfPeriod].hours_consumed).toFixed(2) : 0;
        acc[startOfPeriod].kms_qty = acc[startOfPeriod].quantity ? Number(acc[startOfPeriod].kms_consumed) / Number(acc[startOfPeriod].quantity).toFixed(2) : 0;
        acc[startOfPeriod].qty_kms = acc[startOfPeriod].kms_consumed ? Number(acc[startOfPeriod].quantity) / Number(acc[startOfPeriod].kms_consumed).toFixed(2) : 0;

        acc[startOfPeriod].moving_time += Number(item.moving_time || '0');
        acc[startOfPeriod].idle_time += Number(item.idle_time || '0');

        return acc;
    }, {});
};
